import { DeviceEventEmitter } from 'react-native';

const MASTER_SUBSCRIPTION_CHANGED_EVENT = 'agapella_master_subscription_changed';

export type MasterSubscriptionChangedEvent = {
  userId: string;
  masterId: number;
  isSubscribed: boolean;
};

export const publishMasterSubscriptionChanged = (event: MasterSubscriptionChangedEvent): void => {
  DeviceEventEmitter.emit(MASTER_SUBSCRIPTION_CHANGED_EVENT, event);
};

export const subscribeMasterSubscriptionChanged = (
  listener: (event: MasterSubscriptionChangedEvent) => void,
): (() => void) => {
  const subscription = DeviceEventEmitter.addListener(MASTER_SUBSCRIPTION_CHANGED_EVENT, listener);
  return () => subscription.remove();
};
